import generateAdjustedEventTraits from './generate-adjusted-event-traits';

const getSettingEventTraitsPrefix = (settings, settingId) =>
  settings.find((setting) => setting.id === settingId)?.eventTraitPrefix || settingId;

const getAdjustedOptionsTraits = (diff, changedOptions, matchedSettings) => {
  const traits = Object.keys(diff).reduce((acc, elementId) => {
    if (changedOptions[elementId]) {
      Object.keys(changedOptions[elementId]).forEach((attribute) => {
        if (diff[elementId][attribute] === undefined) return;

        const option = changedOptions[elementId][attribute];
        const { id: optionId, settingId } = option;
        const eventTraitPrefix = getSettingEventTraitsPrefix(matchedSettings, settingId);

        let optionRelatedTraits = {};

        if (typeof option?.getAdjustedEventTraits === 'function') {
          optionRelatedTraits = option.getAdjustedEventTraits({
            eventTraitPrefix,
          });
        }

        if (!Object.keys(optionRelatedTraits).length) {
          optionRelatedTraits = generateAdjustedEventTraits(eventTraitPrefix, optionId);
        }

        Object.assign(acc, optionRelatedTraits);
      });
    }

    return acc;
  }, {});

  return traits;
};

export default getAdjustedOptionsTraits;
